import crypto from 'crypto'
import { MINE_GAME_SIZE } from 'views/InhouseGame/Mine/config'
import { calProbFromHashRange, HASH_HEX_LENGTH } from './baseFairnessResult'

const boardSize = MINE_GAME_SIZE * MINE_GAME_SIZE

export function generateMines(serverSeed: string, clientSeed: string, nonce: number, mines: number): number[] {
  const hashCount = mines / HASH_HEX_LENGTH
  const minesCoord: number[] = []
  const coorsIndexArray: number[] = Array.from({ length: boardSize }, (_, i) => i)

  for (let i = 0; i <= hashCount; i++) {
    const hash = generateHash(serverSeed, clientSeed, nonce, mines, i)
    for (let j = 0; j < HASH_HEX_LENGTH; j++) {
      const mineIndex = i * HASH_HEX_LENGTH + j
      if (mineIndex >= mines) break

      const from = j * HASH_HEX_LENGTH
      const to = (j + 1) * HASH_HEX_LENGTH
      const prob = calProbFromHashRange(hash, from, to)
      const selectMineIndex = Math.floor(prob.toNumber() * (boardSize - mineIndex))
      const mineCoord = coorsIndexArray[selectMineIndex]
      minesCoord.push(mineCoord)
      coorsIndexArray.splice(selectMineIndex, 1)
    }

    if (minesCoord.length >= mines) break
  }

  minesCoord.sort((a, b) => a - b)
  return minesCoord
}

function generateHash(serverSeed: string, clientSeed: string, nonce: number, mines: number, turn: number): string {
  const key = Buffer.from(serverSeed, 'utf-8')
  const message = `${clientSeed}:${nonce}:${mines}:${turn}`

  const hash = crypto.createHmac('sha256', key.toString()).update(message).digest('hex')

  return hash
}
